__turbopack_context__.v({
  "className": "mLV3ka_className",
  "variable": "mLV3ka_variable",
});
